import { render, staticRenderFns } from "./Pendaftaran.vue?vue&type=template&id=6d869d90&scoped=true"
import script from "./Pendaftaran.vue?vue&type=script&lang=js"
export * from "./Pendaftaran.vue?vue&type=script&lang=js"
import style0 from "./Pendaftaran.vue?vue&type=style&index=0&id=6d869d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d869d90",
  null
  
)

export default component.exports